module.exports = __webpack_public_path__ + "static/media/story_wording.b502e8bb.png";